<template>
  <!-- <HelloWorld /> -->
  <div class="home">
    <!-- <h1 class="mx-3 my-3 font-weight-regular headline">Homepage</h1> -->


    <v-layout row wrap align-center justify-center class="mt-5">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
        <v-card class="text-xs-center ma-3" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
          <v-card-text>
            <div class="headline mb-3">Blitz Canvas</div>
            <v-layout align-center justify-center>
              <div
                class="welcome-text subheading"
              >
              <p> Welcome to the section on business model development.</p>

              
              </div>
            </v-layout>
          </v-card-text>

          <v-card-actions class="center">
            <v-layout column align-center justify-center>
              <v-btn dark color="primary" class="mb-3" router to="/bcfoundationelements01">Let's get started!</v-btn>
              <v-btn class="mb-3" router to="/Home">Head back all options</v-btn>
              
            </v-layout>
          </v-card-actions>
        </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import HelloWorld from '../components/HelloWorld' Let's create my first product concept :)

export default {
  name: '',
  data(){
    return{ 
      
    }
  },
  components: {
    //HelloWorld
  }
};
</script>

<style>
.welcome-text {
  text-align: center;
}
</style>
